(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvMenuBarDivider', drvMenuBarDivider);

    drvMenuBarDivider.$inject = [];
    
        /**
     * @ngdoc directive
     * @name drvMenuBarDivider
     * 
     * @description
     * Creates a menu bar divider.
     * To be used with drvMenuBar.
     *   
     */
    function drvMenuBarDivider() {
        var directive = {
            link: link,
            restrict: 'E',
            transclude: true,
            scope: {
            },
            template:
                '<div><md-divider></md-divider></div>'
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }
})();